module.exports = __webpack_public_path__ + "static/media/Infra-SemiBold.634b288e.otf";